import axiosInstance from "@/store/axios.instance";

export default {
    namespaced: true,
    state() {
        return {
            rollen: null,
            rol: null,
        }
    },
    mutations: {
        setRollen(state,rollen){
            state.rollen = rollen
        },
        setRol(state,rol){
            state.rol = rol
        },
        clearRollen(state) {
            state.rollen = null
        }
    },
    actions: {
        fetchRol({commit},naam){
            axiosInstance.get("/zon/rollen/naamrol/" + naam)
                .then(result => commit('setRol',result.data))
        },
        async fetchRollen({commit}){
            axiosInstance.get("/zon/rollen")
                .then(result => commit('setRollen', result.data))
        },
        fetchRolById({commit}, id){
           axiosInstance.get("/zon/rollen/" + id)
                .then(result => commit('setRol', result.data))
        }
    },
    getters:{
        getRolNaamById: (state) => (id) => {
            if (!state.rollen || !Array.isArray(state.rollen)) return null;
            return state.rollen.find(r => r.id === id)?.naam || null;
        }
    },
}